// Estilos compartilhados pelas telas de Alterações Contratuais
// (mesmo padrão visual de Alçadas de Aprovação / Contratos).

export const estiloCabecalho = {
  backgroundColor: "var(--ig-f-1e1e1e)",
  color: "var(--ig-t-ffffff)",
  fontWeight: "bold",
  borderBottom: "1px solid var(--ig-b-444444)",
  whiteSpace: "nowrap",
};

export const estiloCabecalhoInterno = {
  backgroundColor: "var(--ig-f-252525)",
  color: "var(--ig-t-aaaaaa)",
  fontWeight: "bold",
  borderBottom: "1px solid var(--ig-b-444444)",
  py: 0.8,
  whiteSpace: "nowrap",
};

export const estiloCelulaInterna = { borderBottom: "1px solid var(--ig-b-333333)", color: "var(--ig-t-ffffff)", py: 0.8 };

export const estiloBotaoAcao = (cor, corHover) => ({
  backgroundColor: cor,
  color: "#fff",
  borderRadius: "4px",
  mx: 0.25,
  width: "auto",
  "&:hover": { backgroundColor: corHover },
  "&.Mui-disabled": { backgroundColor: "var(--ig-f-333333)", color: "var(--ig-t-666666)" },
});

export const estiloCampo = (somenteLeitura, erro) => ({
  "& .MuiInputLabel-root": { color: erro ? "#f44336" : "var(--ig-t-ffffff)", fontWeight: "bold" },
  "& .MuiOutlinedInput-root": {
    backgroundColor: somenteLeitura ? "var(--ig-f-252525)" : "var(--ig-f-2a2a2a)",
    color: "var(--ig-t-ffffff)",
    "& fieldset": { borderColor: somenteLeitura ? "var(--ig-b-333333)" : erro ? "#f44336" : "var(--ig-b-444444)" },
    "&:hover fieldset": { borderColor: somenteLeitura ? "var(--ig-b-333333)" : erro ? "#f44336" : "var(--ig-b-888888)" },
  },
  "& input, & textarea": { color: "var(--ig-t-ffffff)" },
  "& .MuiFormHelperText-root": { color: erro ? "#f44336" : "var(--ig-t-9ca3af)" },
});

export const estiloSelect = (somenteLeitura, erro) => ({
  backgroundColor: somenteLeitura ? "var(--ig-f-252525)" : "var(--ig-f-2a2a2a)",
  color: "var(--ig-t-ffffff)",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: somenteLeitura ? "var(--ig-b-333333)" : erro ? "#f44336" : "var(--ig-b-444444)" },
  "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: somenteLeitura ? "var(--ig-b-333333)" : erro ? "#f44336" : "var(--ig-b-888888)" },
  "& .MuiSvgIcon-root": { color: somenteLeitura ? "transparent" : "var(--ig-t-ffffff)" },
});

export const estiloCampoInline = {
  "& .MuiOutlinedInput-root": { color: "var(--ig-t-ffffff)", backgroundColor: "var(--ig-f-2a2a2a)", "& fieldset": { borderColor: "var(--ig-b-444444)" } },
  "& input": { color: "var(--ig-t-ffffff)" },
};

export const estiloSelectInline = {
  color: "var(--ig-t-ffffff)",
  backgroundColor: "var(--ig-f-2a2a2a)",
  "& .MuiOutlinedInput-notchedOutline": { borderColor: "var(--ig-b-444444)" },
  "& .MuiSvgIcon-root": { color: "var(--ig-t-ffffff)" },
};

export const estiloBotaoAdicionar = {
  backgroundColor: "#1998a8",
  color: "#fff",
  "&:hover": { backgroundColor: "#1565c0" },
  textTransform: "none",
  fontWeight: "bold",
  width: "auto",
  whiteSpace: "nowrap",
};
